import constate from 'constate'
import { useAliasConstate } from 'hooks'

export enum FormAliasKeys {
  salesChannels = 'salesChannels',
  shippingMethods = 'shippingMethods',
  benefitType = 'benefitType',
  budgetRestrictions = 'budgetRestrictions',
}

export type FormAliasType = {
  [key in FormAliasKeys]: string
}

const [FormAliasProvider, useAddFormAlias, useFormAlias] = constate(
  useAliasConstate<FormAliasType>,
  (value) => ({
    addAlias: value.addAlias,
    removeAlias: value.removeAlias,
  }),
  (value) => ({
    getAlias: value.getAlias,
  })
)

export { FormAliasProvider, useAddFormAlias, useFormAlias }
